"use strict";const t={ODD:185,EVEN:200,DEFAULT:300};exports.TEST_IDS={NAV_TILES:"nav_tiles",NAVBAR_CONTAINER:"navbar_container__"},exports.calculateMinHeight=e=>{const{EVEN:E,ODD:n,DEFAULT:a}=t,c=e%2!=0,r=Math.ceil(e/2);return e>2?r*(c?n:E):a};
//# sourceMappingURL=index-KhD6zXFR.js.map
